import React from 'react';

import { ModalTransition } from '@atlaskit/modal-dialog';

import { useSmartCreationModalStore } from '@confluence/smart-creation-modal-store/entry-points/smartCreationModalStore.tsx';
import { fg } from '@confluence/feature-gating';

import { useCreateWithRovoOpen } from './hooks/useCreateWithRovoOpen.ts';
import { LazyConfluenceSmartCreationModal } from './LazyConfluenceSmartCreationModal.ts';

const ConfluenceSmartCreationModalManagerRenderer = () => {
	const [{ showSmartCreationModal }] = useSmartCreationModalStore();
	useCreateWithRovoOpen();

	return (
		<ModalTransition>
			{showSmartCreationModal && <LazyConfluenceSmartCreationModal />}
		</ModalTransition>
	);
};

export const ConfluenceSmartCreationModalManager = () => {
	if (!fg('aifc_create_enabled')) {
		return null;
	}

	return <ConfluenceSmartCreationModalManagerRenderer />;
};
